import Button, { Kind as ButtonKind, Size as ButtonSize } from '@uds/button';
import { cssTheme } from '@uds/theme-utils';
import { Glyph, IconName } from '@uds/glyphs';
import { useDSTContext } from 'presentation/components/pages/CMPage/DSTContext';
import { useBreakpoints } from '@uds/responsive';
import { RefObject } from 'react';
import { useIntl } from 'react-intl';

import { checkValidity } from './utils';

type Props = {
  glyph?: IconName;
  disabled: boolean;
  label: string | undefined;
  className: string;
  inputRef?: RefObject<HTMLInputElement>;
  checkValidity?: (target: HTMLInputElement) => void;
};

const DomainSearchActionButton = ({ glyph, disabled, label, className, inputRef }: Readonly<Props>) => {
  const { disableCtaButtons } = useDSTContext();
  const { isMinSm } = useBreakpoints();
  const ariaProps = {
    'aria-label': isMinSm ? undefined : label,
  };
  const intl = useIntl();
  const invalidMessage = intl.formatMessage({
    id: 'dst.v2.domain.search.input.errors.short',
  });

  return (
    <Button
      data-testid="domain-search-input-button"
      size={ButtonSize.MD}
      kind={ButtonKind.PRIMARY}
      type="submit"
      block={true}
      {...ariaProps}
      glyph={glyph && <Glyph name={glyph} color={cssTheme.palette.ctaContrast} />}
      disabled={disableCtaButtons || disabled}
      className={className}
      onClick={() => {
        if (inputRef && inputRef.current) {
          checkValidity(inputRef.current, invalidMessage);
        }
      }}
    >
      {isMinSm ? label : undefined}
    </Button>
  );
};

export default DomainSearchActionButton;
